import React, { useEffect, useRef } from 'react'
import { Box, Typography } from '@material-ui/core'

import useStyles, { PREVIEW_HEIGHT } from './styles'

const PREVIEW_RENDER_WIDTH = 600

const TemplatePreview = ({ html, title, fitContent }) => {
  const classes = useStyles()
  const iframeRef = useRef(null)
  const wrapperRef = useRef(null)
  const contentHeightRef = useRef(PREVIEW_HEIGHT)
  const contentWidthRef = useRef(null)

  const applyScale = (containerWidth) => {
    if (containerWidth <= 0) return
    const renderWidth = contentWidthRef.current || containerWidth
    const scale = containerWidth / renderWidth
    const contentHeight = contentHeightRef.current
    const iframeHeight = fitContent
      ? contentHeight
      : Math.round(PREVIEW_HEIGHT / scale)

    if (iframeRef.current) {
      iframeRef.current.style.width = `${renderWidth}px`
      iframeRef.current.style.transform = `scale(${scale})`
      iframeRef.current.style.height = `${iframeHeight}px`
    }
    if (fitContent && wrapperRef.current) {
      wrapperRef.current.style.height = `${Math.round(contentHeight * scale)}px`
    }
  }

  useEffect(() => {
    const wrapper = wrapperRef.current
    if (!wrapper) return

    const observer = new ResizeObserver(([entry]) => {
      applyScale(entry.contentRect.width)
    })

    observer.observe(wrapper)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe || !html) return

    const doc = iframe.contentDocument || iframe.contentWindow?.document
    if (!doc) return

    iframe.style.width = `${PREVIEW_RENDER_WIDTH}px`

    const sanitized = html.replace(/<script[\s\S]*?<\/script>/gi, '')
    doc.open()
    doc.write(sanitized)
    doc.close()

    requestAnimationFrame(() => {
      contentWidthRef.current = PREVIEW_RENDER_WIDTH

      if (fitContent) {
        const height =
          doc.documentElement?.scrollHeight ||
          doc.body?.scrollHeight ||
          PREVIEW_HEIGHT
        contentHeightRef.current = height
      }

      doc.documentElement.style.overflow = 'hidden'
      if (doc.body) doc.body.style.overflow = 'hidden'

      const wrapper = wrapperRef.current
      if (wrapper) applyScale(wrapper.getBoundingClientRect().width)
    })
  }, [html])

  if (!html) {
    return (
      <Box ref={wrapperRef} className={classes.previewPlaceholder}>
        <Typography variant="caption" color="textSecondary">
          Sem preview
        </Typography>
      </Box>
    )
  }

  return (
    <Box ref={wrapperRef} className={classes.previewWrapper}>
      <iframe
        ref={iframeRef}
        title={`Preview: ${title}`}
        className={classes.previewIframe}
      />
    </Box>
  )
}

export default TemplatePreview
